export default __webpack_public_path__ + "static/map-body-fb7711da078b90dce07ff8a6adefdc90.png";